import { RecordContextProvider, Title, useDataProvider, useNotify, useRefresh } from "react-admin";

import BasicInfoSection from "./BasicInfoSection";
import { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router";
import { specialistRequests } from "api/specialistApi";
import SpecializationsSection from "./SpecializationsSection";
import DebtsSection from "./DebtSection";
import DocumentsSection from "./DocumentSection";
import ExamsSection from "./ExamsSection";
import { getDebtsWithTransactions } from "./specialistDebtHelper";
import CampaignApplicationDetailsActions from "./CampaignApplicationDetailsActions";
import { useNotifyError } from "utils/useNotifyError";

const ShowCampaigns = () => {
  const notifyError = useNotifyError();
  const notify = useNotify();
  const location = useLocation();
  const dataProvider = useDataProvider();
  const refresh = useRefresh();
  const campaignId = location?.state?.campaignId;
  const applicationId = location?.state?.applicationId;
  const [details, setDetails] = useState(null);

  const getDetails = useCallback(async () => {
    try {
      const { data } = await dataProvider.customRequest(
        specialistRequests.getCampaignApplicationById(campaignId, applicationId),
      );

      const debts = await getDebtsWithTransactions({
        dataProvider,
        debtIds: data?.debtIds,
        notify,
      });

      setDetails({
        ...data,
        debts,
      });
    } catch (err) {
      notifyError(err);
    }
  }, [campaignId, applicationId, dataProvider, notify, notifyError]);

  useEffect(() => {
    if (!campaignId || !applicationId) return;

    getDetails();
  }, [campaignId, applicationId, getDetails]);

  return (
    details && (
      <RecordContextProvider value={details}>
        <Title title="Детайли на кандидатура към кампания" />
        <CampaignApplicationDetailsActions
          details={details}
          campaignId={campaignId}
          applicationId={applicationId}
          notify={notify}
          refresh={refresh}
          getDetails={getDetails}
        />
        <BasicInfoSection getDetails={getDetails} />
        <DocumentsSection />
        <SpecializationsSection />
        <ExamsSection />
        <DebtsSection />
      </RecordContextProvider>
    )
  );
};

export default ShowCampaigns;
